import styled from 'styled-components';
import { animated } from 'react-spring';

import {
  size,
  mediaQueries,
  InfoBlock as BaseInfoBlock,
  typography,
} from '@everlywell/leaves';

export const InfoBlockContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  ${mediaQueries.forTabletHorizontalUp} {
    justify-content: space-between;
  }
`;

export const AnimatedBlockContainer = styled(animated.div)`
  flex: 1 1 50%;
  max-width: 470px;
`;

export const InfoBlock = styled(BaseInfoBlock).attrs(props => ({
  imageAlt: props.imageAlt,
}))`
  margin-bottom: ${size.xl2}px;

  p {
    font-weight: ${typography.weight.book};
  }

  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: ${size.xl6}px;
  }
`;
